'use client';

import React from 'react';
import Image from 'next/image';

import classes from '../../index.module.css';
import { useRevealGroup } from '../hooks';
import StoreButtons from '../StoreButtons';

const DownloadCTA = () => {
    const groupRef = useRevealGroup<HTMLElement>(classes.revealVisible);

    return (
        <section
            ref={groupRef}
            className='relative overflow-hidden px-4 py-16 md:py-24'
            style={{
                background:
                    'radial-gradient(900px 480px at 15% 10%, rgba(0,143,255,0.3), transparent 60%), radial-gradient(700px 420px at 90% 90%, rgba(35,65,223,0.4), transparent 60%), linear-gradient(180deg, #0a1540, #040a1f)'
            }}
            aria-labelledby='download-app-cta-title'>
            <span className={`${classes.orb} ${classes.orbPrimary} ${classes.orbDrift} -left-24 bottom-0 h-80 w-80`} aria-hidden />
            <div className='desktop-width relative z-10 md:px-8'>
                <div className='mx-auto flex max-w-3xl flex-col items-center text-center'>
                    <div data-reveal className={`${classes.revealPop} ${classes.pulseRing} mb-6 h-[84px]`}>
                        <Image
                            src='/images/logo/Azkiservice_App_Icon.png'
                            alt='آیکون اپلیکیشن ازکی‌سرویس'
                            width={84}
                            height={84}
                            className='h-[84px] w-[84px] rounded-lg shadow-elevation2'
                        />
                    </div>

                    <h2
                        id='download-app-cta-title'
                        data-reveal
                        className={`${classes.reveal} text-2xl font-black leading-[1.4] text-white md:text-4xl md:leading-[1.4]`}
                        style={{ '--reveal-delay': '80ms' } as React.CSSProperties}>
                        همین حالا اپلیکیشن ازکی‌سرویس را دانلود کنید
                    </h2>
                    <p
                        data-reveal
                        className={`${classes.reveal} mt-4 max-w-xl text-sm leading-8 text-whiteMediumEmphasis md:text-base`}
                        style={{ '--reveal-delay': '160ms' } as React.CSSProperties}>
                        نصب رایگان برای اندروید از مایکت؛ کاربران آیفون هم می‌توانند نسخه وب‌اپ را به صفحه اصلی اضافه کنند و اولین سفارش را در چند
                        دقیقه ثبت کنند.
                    </p>

                    <div
                        data-reveal
                        className={`${classes.reveal} mt-8 flex justify-center`}
                        style={{ '--reveal-delay': '240ms' } as React.CSSProperties}>
                        <StoreButtons theme='dark' />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DownloadCTA;
